var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    transform: "scale(1 -1)",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7063 9.78445C15.0597 10.1411 15.0571 10.7167 14.7005 11.0701C14.3439 11.4235 13.7683 11.421 13.4149 11.0644L11.2969 8.92742C10.4374 8.06016 9.84582 7.46525 9.34457 7.0627C8.85767 6.67167 8.54492 6.53752 8.26482 6.50182C8.08895 6.47941 7.91099 6.47941 7.73512 6.50182C7.45502 6.53752 7.14227 6.67167 6.65537 7.0627C6.15412 7.46525 5.56256 8.06016 4.703 8.92742L2.58505 11.0644C2.23162 11.421 1.65602 11.4235 1.29941 11.0701C0.942812 10.7167 0.940244 10.1411 1.29368 9.78445L3.44978 7.60902C4.26183 6.78967 4.92554 6.11999 5.51689 5.64508C6.13183 5.15122 6.756 4.79373 7.50523 4.69823C7.83375 4.65636 8.16619 4.65636 8.49471 4.69823C9.24394 4.79373 9.86811 5.15123 10.483 5.64508C11.0744 6.12 11.7381 6.78966 12.5501 7.60901L14.7063 9.78445Z",
    fill: "#828D99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.b4ab048413d1383de711c6b0cd16bd4d.svg";
export { ForwardRef as ReactComponent };